import {Navigate} from "react-router-dom";
import {getMergeAccount, useMergeAccount} from "./useMergeAccount";
import {FC, useEffect} from "react";
import {FullPageSpinner} from "../loading/Spinner";
import {useNavigate} from "react-router";
import {ExistingUserCard} from "../user/ExistingUserCard";
import {translateKey} from "../language/translate";
import {toAuthMethod, trackAccountLinkRequested} from "../../analytics/mixpanel";

export const MergeAccount: FC = () => {
  const mergeAccount = useMergeAccount();
  const navigate = useNavigate();

  useEffect(() => {
    if (mergeAccount.status == "link") {
      const method = toAuthMethod(getMergeAccount().identityProvider || "");
      if (method) {
        trackAccountLinkRequested(method);
      }
      console.log("Merging accounts", mergeAccount);
      mergeAccount.linkAccounts().then(() => navigate("/authenticated")).catch(err => {
        console.error("error linking accounts", err)
        navigate("/error");
      });
    }
  }, [mergeAccount.status]);

  if (mergeAccount.status === "loading") {
    return <FullPageSpinner/>
  }
  if (mergeAccount.status === "redirect") {
    return <Navigate to={mergeAccount.path}/>;
  }
  if (mergeAccount.status === "link") {
    return <FullPageSpinner/>
  }
  if (mergeAccount.status === "sign-in") {
    return <ExistingUserCard email={mergeAccount.email}
                             continueMessage={translateKey("account:user.existing.card.merge.continueMsg")}/>;
  }
  return null;
};
